var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"auto","text-align":"center","margin-top":"100px"}},[_c('h1',[_vm._v("Flower LANDING")]),_c('router-link',{attrs:{"to":{ name: 'login' }}},[_c('span',[_vm._v("Connexion")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }